import { formatNumber } from "@/lib/format";
import { PropertyValueRow } from "../types/webstoreAnalytics";
import { Row, TablePanel, Td, Th } from "./AnalyticsTable";

interface TopPropertyTableProps {
  title: string;
  subtitle: string;
  valueHeader: string;
  countHeader: string;
  rows: PropertyValueRow[];
  empty: string;
}

/**
 * Top values of one event property — most-viewed items, most-added items, most-run
 * searches.
 *
 * These come from the free-form `properties` JSON on the event, so a value only
 * appears if the storefront actually tagged it. An empty panel here means the events
 * arrived without that property, not that nothing happened.
 */
export function TopPropertyTable({
  title,
  subtitle,
  valueHeader,
  countHeader,
  rows,
  empty,
}: TopPropertyTableProps) {
  return (
    <TablePanel
      title={title}
      subtitle={subtitle}
      isEmpty={rows.length === 0}
      empty={empty}
      head={
        <>
          <Th>{valueHeader}</Th>
          <Th align="right">{countHeader}</Th>
          <Th align="right">Sessions</Th>
        </>
      }
    >
      {rows.map((row) => (
        <Row key={row.value}>
          <Td className="font-medium text-slate-800 truncate max-w-[280px]" >{row.value}</Td>
          <Td align="right">{formatNumber(row.event_count)}</Td>
          <Td align="right">{formatNumber(row.sessions)}</Td>
        </Row>
      ))}
    </TablePanel>
  );
}
